import {
    FETCH_ALL_PROJECT_ISSUE_SUCCESS,
    FETCH_PROJECT_ISSUE_SUCCESS,
    FILTER_PROJECT_ISSUE,
    GET_ALL_PROJECT_ISSUE,
    GET_UNSELECTED_ALL_PROJECT_ISSUE,
    HANDLE_PROJECT_ISSUE_REQUEST_CLOSE,
    HIDE_PROJECT_ISSUE_LOADER,
    SHOW_PROJECT_ISSUE_LOADER,
    ON_ADD_PROJECT_ISSUE,
    ON_ADD_JIRA_PROJECT_ISSUE,
    ON_PROJECT_ISSUE_CLOSE,
    ON_DELETE_PROJECT_ISSUE_SUCCESS,
    ON_FILTER_SELECTED_PROJECT_ISSUE,
    ON_FILTER_PROJECT_ISSUE_OPTION_SELECT,
    ON_SAVE_PROJECT_ISSUE_SUCCESS,
    ON_TOGGLE_PROJECT_ISSUE_DRAWER,
    SHOW_PROJECT_ISSUE_MESSAGE,
    UPDATE_SEARCH_PROJECT_ISSUE,
    CLEAR_SESSION,
    ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS,
    SET_PROJECT_ISSUE,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All project issues';
export const STARRED_FILTER = 'Starred project issues';
export const SUCCESSFUL_UPDATE = 'Project issue Updated Successfully';
export const SUCCESSFUL_FILTER = 'Project issue Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Project issue Deleted Successfully';
export const REMOVED_AS_STAR = 'Project issue removed as star';
export const MARKED_AS_STAR = 'Project issue marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No project issues found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allProjectIssue: [],
    projectIssueList: [],
    selectedProjectIssue: null,
    selectedProjectIssues: 0,
    addProjectIssueState: false,
    addJiraProjectIssueState: false,
    searchProjectIssue: '',
    projectIssueCacheList: [],
    projectIssue: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS: {
            return {
                ...state,
                projectIssueCacheList: action.payload,
            };
        }
        case FETCH_PROJECT_ISSUE_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedProjectIssue: action.payload,
            };
        }
        case SET_PROJECT_ISSUE: {
            const projectIssue = state.allProjectIssue.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedProjectIssue: projectIssue?.length > 0 ? projectIssue[0] : [],
            };
        }
        case FETCH_ALL_PROJECT_ISSUE_SUCCESS: {
            return {
                ...state,
                loader: false,
                allProjectIssue: action.payload,
                projectIssueList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                selectedProjectIssue: null,
            };
        }
        case SHOW_PROJECT_ISSUE_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_ADD_PROJECT_ISSUE: {
            return { ...state, addProjectIssueState: true };
        }
        case ON_ADD_JIRA_PROJECT_ISSUE: {
            return { ...state, addJiraProjectIssueState: true };
        }
        case ON_PROJECT_ISSUE_CLOSE: {
            return { ...state, addProjectIssueState: false };
        }
        case ON_FILTER_PROJECT_ISSUE_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let projectIssueList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectIssueList = state.allProjectIssue;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectIssueList = state.allProjectIssue.filter((projectIssue) => projectIssue.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, projectIssueList, drawerState: false
            };
        }
        case ON_SAVE_PROJECT_ISSUE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                projectIssueList: addOrUpdateEntry(state.projectIssueList, action.payload),
                allProjectIssue: addOrUpdateEntry(state.allProjectIssue, action.payload),
                selectedProjectIssue: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_PROJECT_ISSUE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allProjectIssue: state.allProjectIssue.filter((projectIssue) => projectIssue.id !== action.payload),
                projectIssueList: state.allProjectIssue.filter((projectIssue) => projectIssue.id !== action.payload),
                selectedProjectIssue: null,
            };
        }
        case ON_FILTER_SELECTED_PROJECT_ISSUE: {
            const projectIssues = state.allProjectIssue.filter((projectIssue) => !projectIssue.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                allProjectIssue: projectIssues,
                projectIssueList: projectIssues,
                selectedProjectIssues: 0
            };
        }
        case FILTER_PROJECT_ISSUE: {
            const { filterOption } = state;
            let projectIssueList = [];
            if (action.payload === '') {
                projectIssueList = state.allProjectIssue;
            } else {
                const filterProjectIssue = state.allProjectIssue.filter((projectIssue) =>
                    projectIssue.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    projectIssueList = filterProjectIssue;
                } else if (filterOption === STARRED_FILTER) {
                    projectIssueList = filterProjectIssue.filter((projectIssue) => projectIssue.starred);
                }
            }
            return { ...state, projectIssueList: projectIssueList };
        }
        case GET_ALL_PROJECT_ISSUE: {
            let projectIssueList = state.allProjectIssue.map((projectIssue) => projectIssue ? {
                ...projectIssue,
                selected: true
            } : projectIssue);
            return {
                ...state,
                selectedProjectIssues: projectIssueList.length,
                allProjectIssue: projectIssueList,
                projectIssueList: projectIssueList
            };
        }
        case GET_UNSELECTED_ALL_PROJECT_ISSUE: {
            let projectIssueList = state.allProjectIssue.map((projectIssue) => projectIssue ? {
                ...projectIssue,
                selected: false
            } : projectIssue);
            return {
                ...state,
                selectedProjectIssues: 0,
                allProjectIssue: projectIssueList,
                projectIssueList: projectIssueList
            };
        }
        case UPDATE_SEARCH_PROJECT_ISSUE: {
            return { ...state, searchProjectIssue: action.payload };
        }
        case HANDLE_PROJECT_ISSUE_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PROJECT_ISSUE_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PROJECT_ISSUE_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PROJECT_ISSUE_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/projectIssue.js